import { fetchArticle } from '@/redux/modules/article/article.actions';
import { getArticle } from '@/redux/modules/article/article.selectors';
import { beginArticleLinksNavigation } from '@/redux/modules/articleLinks/articleLinks.actions';
import { fetchArticleLinksIfCurrent } from '@/redux/modules/articleLinks/articleLinks.loader';
import { fetchArticleRelatedItemsIfCurrent } from '@/redux/modules/articleRelatedItems/articleRelatedItems.loader';
import { getArticleRelatedItemIds } from '@/redux/modules/articleRelatedItems/articleRelatedItems.selectors';
import { fetchItemSummariesIfNeeded } from '@/redux/modules/item/summary/itemSummary.actions';
import { DataLoaderParams } from '@/types/DataLoaderParams';

import { getArticlePageLinksParams } from './getArticlePageLinksParams';
import { getArticleRelatedItemsKeyword } from './getArticleRelatedItemsKeyword';

/**
 * Loads article data for `/guides/:topic/:slug`.
 */
export const articlePageData = async ({
    amplitudeExperimentFlags,
    match: { params },
    store: { dispatch, getState },
}: DataLoaderParams) => {
    const { slug, topic } = params;

    if (!topic || !slug) {
        return;
    }

    const articleLinksNavigationId = dispatch(beginArticleLinksNavigation());

    await dispatch(fetchArticle({ slug, topic }));

    const article = getArticle(getState());
    await Promise.all([
        fetchArticleLinksIfCurrent({
            amplitudeExperimentFlags,
            dispatch,
            getState,
            navigationId: articleLinksNavigationId,
            params: getArticlePageLinksParams(article),
        }),
        fetchArticleRelatedItemsIfCurrent({
            amplitudeExperimentFlags,
            dispatch,
            keyword: getArticleRelatedItemsKeyword(article),
        }),
    ]);

    const relatedItemIds = getArticleRelatedItemIds(getState());
    if (relatedItemIds.length > 0) {
        await dispatch(
            fetchItemSummariesIfNeeded({
                identifier: 'ARTICLE-RELATED-ITEMS',
                itemIds: relatedItemIds,
            })
        );
    }
};
